import { render, staticRenderFns } from "./SliderArrowsComponent.vue?vue&type=template&id=e5c76b02"
import script from "./SliderArrowsComponent.vue?vue&type=script&lang=js"
export * from "./SliderArrowsComponent.vue?vue&type=script&lang=js"
import style0 from "./SliderArrowsComponent.vue?vue&type=style&index=0&id=e5c76b02&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports